import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import ui from './module.ui';
import data from './module.data';
import wizard from './module.wizard';
import identify from './module.identify';
import filters from './module.filters';
import models from './module.models';
import mapping from './module.mapping';

Vue.use(Vuex);

const defaultState = {};

const store = new Vuex.Store({
  // strict: process.env.NODE_ENV === 'development',
  strict: true,
  modules: {
    ui,
    data,
    wizard,
    identify,
    filters,
    models,
    mapping,
  },
  plugins: [createPersistedState({
    key: 'cesBroadbandApp',
    // storage: window.localStorage,
    paths: [
      'data',
      'wizard.preferences',
    ],
  })],
  state: defaultState,
});

// store.subscribe((mutation, state) => {
//   if (mutation.type === 'SET_PREFERENCES') {
//     console.log(mutation.type);
//     console.log(JSON.stringify(mutation.payload, null, ' '));
//     console.log(state.wizard.preferences.scale.value);
//     console.log(state);
//   }
// });

// store.subscribeAction((action) => {
//   console.warn(`VUEX ACTION: ${action.type}`);
//   console.info(action.payload);
// });

export default store;
